/**
 * Returns true if the given value is a "safe" image URL — relative path,
 * http://, or https://. Anything else (javascript:, data:, blob:, ...)
 * is rejected to avoid XSS through inventory-supplied URLs.
 */
const isSafeImageUrl = (value) =>
  typeof value === 'string' &&
  (value.startsWith('/') ||
    value.startsWith('http://') ||
    value.startsWith('https://'));

/**
 * Picks the source image path for the landing hero.
 *
 *  - For new-model cars (Autodis OMODA/JAECOO, issue #884) prefers
 *    `landscapeImage` when present — wide 16:9 hero shot from
 *    omodajaecoo.be designed for full-screen presentation.
 *  - Otherwise: first image whose URL contains "main", else first safe URL.
 *
 * Returns `null` if no usable image exists.
 *
 * @param {object|null|undefined} car — Car object (DealerCarDto).
 * @returns {string|null}
 */
export const pickHeroImageSource = (car) => {
  if (!car) return null;
  if (car.isNewModel && isSafeImageUrl(car.landscapeImage)) {
    return car.landscapeImage;
  }
  if (!car.images?.length) return null;
  const mainImg = car.images.find(
    (u) => isSafeImageUrl(u) && u.toLowerCase().includes('main'),
  );
  return mainImg || car.images.find(isSafeImageUrl) || null;
};
